module.exports = __webpack_public_path__ + "img/5.92ab1b66.png";